export default function roundToNearestHalf(value: number): number {
  return Math.round(value * 2) / 2;
}
